import React, { useEffect, useState } from 'react';
import Button from '../components/Button/Button';
import { toast } from 'react-toastify';
import useFormValidation from '../hooks/useFormValidation';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { loginFormValidationSchema } from '../utils/formValidation';
import { AiOutlineLoading } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { passport } from '../utils/constant';
import { errorToast } from '../utils/errorHandling';
import { Link, useNavigate } from 'react-router-dom';
import { getActiveCourse } from '../services/settings';
import { userLogin } from '../services/authApi';

const base_url = process.env.REACT_APP_BASE_URL;

const Login = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const navigate = useNavigate();
    // const [formData, setFormData] = useState({ mobile: "", password: "", countryCode: "86" });
    const [formData, setFormData] = useState({ student_no: "", password: "" });
    const { errors, validateField, validateAllFields } = useFormValidation(loginFormValidationSchema(t));
    const [showPassword, setShowPassword] = useState(true);
    const countryCodeList = passport(t);
    // const sortedCountries = [...countryCodeList].sort((a, b) => {
    //     return parseInt(a.countryCodeValue) - parseInt(b.countryCodeValue);
    // });
    const handleToggle = () => {
        setShowPassword(!showPassword);
    }
    const fetchActiveCourse = async () => {
        setIsLoading(true);
        try {
            const response = await getActiveCourse();
            const data = response.data.data;

            if (response.status === 200) {
                if (data.length === 0) {
                    setCourseData(null);
                } else {
                    setCourseData(data[0]);
                }
            } else {
                toast.error(t('general.ActionFailed'));
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        // if (name == "countryCode") {
        //     setFormData((prevState) => ({
        //         ...prevState,
        //         [name]: value,
        //     }));
        //     validateField(name, id);
        // } else if (id == 'mobile') {
        //     if (value !== '') {
        //         if (/^[1-9]\d*$/.test(value)) {
        //             setFormData((prevState) => ({
        //                 ...prevState,
        //                 [id]: value,
        //             }));
        //         }
        //     } else {
        //         setFormData((prevState) => ({
        //             ...prevState,
        //             [id]: value,
        //         }));
        //     }
        //     validateField(id, value);
        // } else {
        //     setFormData((prevState) => ({
        //         ...prevState,
        //         [id]: value,
        //     }));
        //     validateField(id, value);
        // }
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value);
    };

    const handleSubmit = async () => {
        const includeFields = Object.keys(formData);
        if (validateAllFields(formData, includeFields)) {
            try {
                setIsLoading(true);
                const response = await userLogin(formData);
                const data = response.data.data;
                if (data === 404) {
                    toast.error(t("login.invalidUsername"));
                } else if (data === 401) {
                    toast.error(t("login.invalidCredentials"));
                } else {
                    toast.success(t("login.loginSuccess"));
                    navigate(`${base_url}/`)
                }
            } catch (error) {
                errorToast(error, t("general.ActionFailed"), t);
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error(t("general.ValidationFail"));
        }
    };

    useEffect(() => {
        fetchActiveCourse();
    }, []);

    return (
        <>
            {
                isLoading && !courseData ?
                    <div className='m-5 d-flex justify-content-center'>
                        <AiOutlineLoading className='spin' />
                    </div>
                    :
                    !courseData ?
                        <>
                            <div className='form-wrapper d-flex flex-column'>
                                <h3 className='mt-5 d-flex justify-content-center'>{t("login.notOpen")}</h3>
                            </div>
                        </>

                        :
                        <>
                            <div className='login-page-button'>
                                <Link to={`${base_url}/course_registration`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("navbar.courseRegistration")}</Button>
                                </Link>
                                <Link to={`${base_url}/search_eligibility`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("navbar.eligibilityCheck")}</Button>
                                </Link>
                            </div>
                            <div className='form-wrapper d-flex flex-column'>
                                <h3 className='mt-5 d-flex justify-content-center'>{t("login.title")}</h3>
                                <p className='d-flex justify-content-center text-center'>{localStorage.getItem("i18nextLng") === "en" ? courseData.course_ename : courseData.course_cname}</p>
                                <form>
                                    <div className="input-group d-flex justify-content-center">
                                        {/* <select
                                            className="form-select"
                                            style={{ maxWidth: '200px' }}
                                            value={formData.countryCode}
                                            onChange={handleInputChange}
                                            name="countryCode"
                                        >
                                            {
                                                sortedCountries.map((sortedCountries) => (
                                                    <option value={sortedCountries.countryCodeValue}>{sortedCountries.countryCodeLabel}</option>
                                                ))
                                            }
                                        </select> */}
                                        <input
                                            type="text"
                                            value={formData?.student_no || ""}
                                            className="form-control"
                                            id="student_no"
                                            placeholder={t("login.studentNo")}
                                            onChange={handleInputChange}
                                            name="student_no"
                                            required
                                        />
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        {errors.student_no && <span className="error">{errors.student_no}</span>}
                                    </div>
                                    <div className="password-input mt-3">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            value={formData?.password || ""} className="form-control"
                                            id="password"
                                            placeholder={t("login.password")}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <span className="position-absolute eye-icon" onClick={handleToggle}>
                                            {showPassword ?
                                                <IoEye className='absolute' />
                                                :
                                                <IoEyeOff className='absolute' />
                                            }
                                        </span>
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        {errors.password && <span className="error">{errors.password}</span>}
                                    </div>
                                    <div className='submit-button mt-4 d-flex justify-content-center'>
                                        <Button buttonStyle='btn--primary' disabled={isLoading} onClick={handleSubmit} type='button'>
                                            {isLoading ? <AiOutlineLoading className="spin" /> : t('login.save')}
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </>
            }
        </>
    )
}

export default Login